module.exports = __webpack_public_path__ + "static/media/biteship-via-plugin.98d77fb2.png";